import evalutionMode from "../../assets/evalutionMode.png";
import practiceMode from "../../assets/practiceMode.png";

const ExamMode = ({ mode, examModeHandler, startExamHandler }) => {
  return (
    <div className="p-10 mt-10 flex flex-col gap-5 border border-gray-300 rounded-lg shadow-md">
      <span className="text-xl font-bold text-blue-900">Exam Mode</span>
      <div className="grid gap-10 grid-cols-2">
        <div
          onClick={() => examModeHandler("eval")}
          className={`flex flex-col gap-8 cursor-pointer border ${
            mode ? "border-green-500" : "border-red-500"
          } text-white p-5 rounded-md ${mode ? "bg-green-400" : "bg-red-400"}`}
        >
          <div className="flex justify-between items-center">
            <span className="rounded-lg">
              <img src={evalutionMode} alt="evalutionMode" />
            </span>
            {mode && (
              <span className="rounded-xl bg-white">
                <svg
                  className="h-6 w-6 text-green-500"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M5 13l4 4L19 7"
                  />
                </svg>
              </span>
            )}
          </div>
          <h2 className="text-lg font-bold">Evaluation Mode</h2>
          <p>
            In this option, you can see the answer to each question at the end
            of the quiz. This option is useful for those who want to evaluate
            their study progress.
          </p>
        </div>
        <div
          onClick={() => examModeHandler("practice")}
          className={`flex flex-col gap-8 cursor-pointer border ${
            !mode ? "border-green-500" : "border-blue-500"
          } text-white p-5 rounded-md ${
            !mode ? "bg-green-400" : "bg-blue-400"
          }`}
        >
          <div className="flex justify-between items-center">
            <span className="rounded-lg">
              <img src={practiceMode} alt="practiceMode" />
            </span>
            {!mode && (
              <span className="rounded-xl bg-white">
                <svg
                  className="h-6 w-6 text-green-500"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M5 13l4 4L19 7"
                  />
                </svg>
              </span>
            )}
          </div>
          <h2 className="text-lg font-bold">Practice Mode</h2>
          <p>
            In this option, you can see the answer to each question immediately
            after solving it. This option is useful for those who are just
            starting their study session.
          </p>
        </div>
      </div>

      <div className="flex justify-center items-center mt-10">
        <button
          onClick={startExamHandler}
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default ExamMode;
